import React from 'react';
import { Card, Typography, Box, Button } from '@mui/material';
import { styled } from '@mui/system';
import Avatar from '@mui/material/Avatar';

const CustomCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    backgroundColor: 'white', // Adjust the background color if needed
}));

const CardMediaBox = styled(Box)(({ theme, bgcolor }) => ({
    width: 30,
    height: 25,
    backgroundColor: bgcolor || '#f4c017', // Use color from props or default
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    borderRadius: 8,
}));

const CustomButton = styled(Button)(({ theme, btnBgColor }) => ({
    backgroundColor: btnBgColor || '#f9e5a1',
    color: '#666666',
    borderRadius: 10,
    padding: theme.spacing(0.5, 1),
    textTransform: 'none',
    '&:hover': {
        backgroundColor: btnBgColor || '#f5d992',
    },
}));

export const CourseCard = ({ mediaText = "U", mediaColor = "#f4c017", title = "UI/UX Design", subtitle = "30+ Courses", buttonText = "View Courses", btnBgColor }) => {
    return (
        <CustomCard elevation={1} sx={{ my: { xs: 1, md: 1 } }}>
            <CardMediaBox bgcolor={mediaColor}>
                <Typography variant="h5" component="div" color="white">
                    {mediaText}
                </Typography>
            </CardMediaBox>
            <Box ml={2} flexGrow={1} display="flex" flexDirection="column" gap={0} >
                <Typography variant="subtitle2" component="div" fontWeight={600}>
                    {title}
                </Typography>
                {/* <Typography variant="caption" color="textSecondary">
                    {subtitle}
                </Typography> */}
            </Box>
            <CustomButton variant="contained" size="small" btnBgColor={btnBgColor} disableElevation>
                <Typography variant="caption" fontSize="10px" fontWeight={600} color={mediaColor}>
                    {buttonText}
                </Typography>
            </CustomButton>
        </CustomCard>
    );
};

const CustomButton2 = styled(Button)(({ theme }) => ({
    background: "#E6E6E6",
    color: 'black',
    borderRadius: 10,
    padding: theme.spacing(0.5),
    textTransform: 'none',
    '&:hover': {
        backgroundColor: '#E6E6E6',
    },
}));


export const CourseTrainerCard = ({ title = "Unknown", mediaColor = "green" }) => {
    return (
        <CustomCard elevation={1} sx={{ my: { xs: 1, md: 1 } }}>
            <Avatar alt={title[0]} sx={{ bgcolor: mediaColor }} />
            <Box ml={2} flexGrow={1}>
                <Typography variant="subtitle2" component="div" fontWeight={600}>
                    {title}
                </Typography>
                {/* <Typography variant="body2" color="textSecondary">
                    {subtitle}
                </Typography> */}
            </Box>
            <CustomButton2  >
                <Typography variant="caption" fontSize="10px" fontWeight={600} >
                    Courses
                </Typography>
            </CustomButton2>
        </CustomCard>
    );
};